module.exports = __webpack_public_path__ + "img/ic_initiative.dc65b629.png";